import type { ServicePage } from "./types";

export const produtoPages: ServicePage[] = [
  {
    slug: "porta-chaveiro",
    keyword: "porta chaveiro",
    title: "Porta Chaveiro Personalizado em Betim | Chavel",
    description:
      "Porta chaveiro personalizado e chaveiros para empresas, brindes e organização de chaves em Betim. Av. Amazonas, 1354 - (31) 3531-3544.",
    h1: "Porta chaveiro e chaveiros personalizados em Betim",
    lead: "Além dos serviços de chavearia, a Chavel trabalha com porta chaveiro de parede, chaveiros personalizados e identificação de chaves — itens simples que resolvem a bagunça de quem administra muitas cópias.",
    category: "produto",
    quickAnswer:
      "A Chavel, em Betim, vende porta chaveiro de parede e chaveiros personalizados, além de fazer gravação e identificação de chaves para casas, condomínios e empresas. Loja: Av. Amazonas, 1354 - Brasiléia. Contato: (31) 3531-3544.",
    sections: [
      {
        h2: "Tipos de porta chaveiro",
        paragraphs: [
          "A escolha depende de quantas chaves você guarda e de quem precisa ter acesso a elas.",
        ],
        h3: [
          { title: "Porta chaveiro de parede", text: "Ideal para uso doméstico, mantém as chaves visíveis perto da porta de entrada." },
          { title: "Quadro com fechadura", text: "Recomendado para portarias, hotéis e empresas, com trava e numeração dos ganchos." },
          { title: "Chaveiro identificador", text: "Etiquetas e argolas coloridas para diferenciar chaves parecidas sem depender da memória." },
        ],
      },
      {
        h2: "Organização de chaves em condomínios",
        paragraphs: [
          "Portaria com chaves soltas em gaveta é risco de segurança. Um quadro com fechadura, numeração e registro de retirada reduz perdas e deixa claro quem usou cada chave.",
        ],
      },
      {
        h2: "Brindes e personalização",
        paragraphs: [
          "Chaveiros personalizados com nome, logotipo ou telefone são usados por comércios de Betim como brinde e como forma de o cliente lembrar do contato. Fazemos também carimbos sob encomenda.",
        ],
      },
    ],
    faq: [
      {
        q: "Vocês personalizam chaveiro com logotipo?",
        a: "Sim, sob encomenda. Traga a arte ou descreva o que deseja na loja.",
      },
      {
        q: "Fazem identificação de chaves de condomínio?",
        a: "Sim, com numeração e etiquetas resistentes.",
      },
    ],
    related: ["chaveiro-betim", "chaveiro-brasileia", "fechaduras-de-porta", "chaveiro-a-domicilio"],
  },
  {
    slug: "fechaduras-de-porta",
    keyword: "fechaduras de porta",
    title: "Fechaduras de Porta em Betim | Venda e Instalação | Chavel",
    description:
      "Fechaduras de porta em Betim: tetra, cilindro, multiponto e de segurança. Venda, troca e instalação pela Chavel - (31) 3531-3544.",
    h1: "Fechaduras de porta: tipos, escolha e instalação",
    lead: "A fechadura é o item de segurança mais barato da casa e o mais negligenciado. Trocar um cilindro comum por um de segurança custa pouco e muda o nível de proteção da porta.",
    category: "produto",
    quickAnswer:
      "A Chavel vende e instala fechaduras de porta em Betim: cilindro comum, cilindro de segurança, tetra, multiponto, digital e elétrica. Loja na Av. Amazonas, 1354 - Brasiléia. Contato: (31) 3531-3544.",
    sections: [
      {
        h2: "Principais tipos de fechadura",
        paragraphs: [
          "Cada tipo atende a um uso e a um nível de segurança diferente.",
        ],
        h3: [
          { title: "Fechadura de cilindro", text: "A mais comum em portas residenciais. Barata e fácil de trocar; a segurança depende da qualidade do cilindro." },
          { title: "Fechadura tetra", text: "Chave de quatro faces, mais difícil de copiar e mais resistente à violação por gazua." },
          { title: "Fechadura multiponto", text: "Trava a porta em vários pontos ao mesmo tempo. Padrão em portas de alta segurança e blindadas." },
          { title: "Fechadura de rolete", text: "Muito usada em portas de entrada, com boa resistência a arrombamento por impacto." },
        ],
      },
      {
        h2: "Como escolher a fechadura certa",
        paragraphs: [
          "Considere o material da porta, a exposição à rua, o número de pessoas que usam a chave e a frequência de uso. Porta de entrada exposta pede cilindro de segurança e contra-testa reforçada; porta interna aceita solução simples.",
        ],
        bullets: [
          "Porta de entrada: cilindro de segurança, tetra ou multiponto",
          "Porta interna: fechadura de passagem ou com trava simples",
          "Banheiro: fechadura com trava interna e destrave de emergência",
          "Comércio: fechadura de alta rotatividade e barra antipânico quando exigido",
        ],
      },
      {
        h2: "Quando trocar em vez de consertar",
        paragraphs: [
          "Chave que precisa ser 'ajeitada' para girar, trinco que não recolhe totalmente e ferrugem visível são sinais de fim de vida útil. Nesses casos a troca custa menos que a soma dos reparos e evita ficar trancado do lado de fora.",
        ],
      },
    ],
    faq: [
      {
        q: "Vocês instalam fechadura comprada em outro lugar?",
        a: "Sim, cobrando apenas a mão de obra, desde que a peça seja compatível com a porta.",
      },
      {
        q: "Dá para manter a mesma chave em várias portas?",
        a: "Sim, é possível padronizar cilindros para que uma chave abra portas diferentes.",
      },
      {
        q: "Quanto tempo demora uma troca de fechadura?",
        a: "Uma troca simples leva de 20 a 40 minutos; multiponto e portas blindadas exigem mais tempo.",
      },
    ],
    related: ["fechadura-digital", "fechadura-de-porta-madeira", "chaveiro-a-domicilio", "chaveiro-betim"],
  },
  {
    slug: "fechadura-digital",
    keyword: "fechadura digital",
    title: "Fechadura Digital em Betim | Instalação | Chavel",
    description:
      "Fechadura digital em Betim: biometria, senha, cartão e app. Venda e instalação pela Chavel — (31) 3531-3544.",
    h1: "Fechadura digital: instalação em Betim",
    lead: "Fechadura digital elimina a chave física, permite senha temporária para visitas e registra quem entrou. É a atualização mais prática para quem cansou de fazer cópias.",
    category: "produto",
    quickAnswer:
      "A Chavel vende e instala fechadura digital em Betim, com abertura por biometria, senha, cartão, tag ou aplicativo. Avaliação da porta e orçamento pelo WhatsApp (31) 3531-3544.",
    sections: [
      {
        h2: "Formas de abertura",
        paragraphs: [
          "A maioria dos modelos combina mais de um método, e é isso que garante que você nunca fique do lado de fora.",
        ],
        bullets: [
          "Biometria (digital) — rápida e sem nada para carregar",
          "Senha numérica — permite código temporário para diarista ou hóspede",
          "Cartão ou tag de aproximação — prático para famílias e equipes",
          "Aplicativo por Wi-Fi ou Bluetooth — abertura remota e histórico de acessos",
          "Chave mecânica de emergência — backup obrigatório em bons modelos",
        ],
      },
      {
        h2: "Sua porta suporta fechadura digital?",
        paragraphs: [
          "Nem toda porta aceita qualquer modelo. Espessura, material, sentido de abertura e a furação existente definem o modelo compatível. Portas de madeira maciça e de alumínio geralmente aceitam; portas muito finas ou de vidro exigem modelos específicos.",
        ],
      },
      {
        h2: "Dúvidas comuns sobre energia e segurança",
        paragraphs: [
          "Fechaduras digitais funcionam com pilhas ou bateria, com autonomia de meses e aviso de bateria fraca. Na falta total de carga, a chave mecânica ou uma bateria externa de emergência resolve. Para segurança, prefira modelos com bloqueio após tentativas erradas e senha aleatória (código falso) antes da senha real.",
        ],
      },
      {
        h2: "Instalação profissional x por conta própria",
        paragraphs: [
          "A furação errada não tem volta: compromete a porta e a garantia. A instalação profissional inclui medição, adequação do batente, configuração das senhas e teste completo do conjunto.",
        ],
      },
    ],
    faq: [
      {
        q: "Fechadura digital é segura contra arrombamento?",
        a: "Modelos de qualidade têm trava mecânica robusta e alarme. A segurança depende também do reforço da porta e do batente.",
      },
      {
        q: "E se acabar a bateria?",
        a: "Há aviso prévio de bateria fraca; na emergência usa-se a chave mecânica ou alimentação externa, conforme o modelo.",
      },
      {
        q: "Vocês configuram o aplicativo?",
        a: "Sim, deixamos as senhas, digitais e o app configurados e testados na instalação.",
      },
    ],
    related: ["fechaduras-de-porta", "fechadura-eletronica-portao", "chaveiro-a-domicilio", "fechadura-de-porta-madeira"],
  },
  {
    slug: "fechadura-de-porta-madeira",
    keyword: "fechadura de porta madeira",
    title: "Fechadura para Porta de Madeira em Betim | Chavel",
    description:
      "Fechadura de porta de madeira em Betim: troca, instalação e ajuste sem danificar a porta. Chavel - (31) 3531-3544.",
    h1: "Fechadura para porta de madeira",
    lead: "Porta de madeira é a mais comum nas casas de Betim e também a mais sensível: a mesma umidade que faz a madeira inchar é o que trava a fechadura no inverno seguinte.",
    category: "produto",
    quickAnswer:
      "A Chavel troca, instala e ajusta fechaduras para portas de madeira em Betim, respeitando a furação existente sempre que possível. Atendimento a domicílio pelo (31) 3531-3544.",
    sections: [
      {
        h2: "Tipos de fechadura para madeira",
        paragraphs: [
          "A escolha depende da espessura da porta e do uso do ambiente.",
        ],
        bullets: [
          "Fechadura de embutir com cilindro — padrão em portas de entrada",
          "Fechadura tetra — mais segurança para porta externa",
          "Fechadura de sobrepor — usada em portas antigas e de fundos",
          "Fechadura de banheiro — sem chave, com trava interna",
          "Fechadura de passagem — sem trava, para portas internas",
        ],
      },
      {
        h2: "Porta que arrasta e fechadura que não fecha",
        paragraphs: [
          "Antes de trocar a fechadura, vale ajustar. Dobradiça folgada, contra-testa desalinhada e madeira inchada são as três causas principais. O ajuste correto costuma resolver sem substituir a peça.",
        ],
      },
      {
        h2: "Troca sem danificar a porta",
        paragraphs: [
          "Substituir por um modelo com a mesma distância de broca e o mesmo formato de testa evita rasgo na madeira. Quando a furação é diferente, usamos espelho de acabamento ou fazemos o enxerto correto para não deixar a porta marcada.",
        ],
      },
    ],
    faq: [
      {
        q: "Dá para colocar fechadura digital em porta de madeira?",
        a: "Sim, desde que a espessura seja compatível com o modelo escolhido.",
      },
      {
        q: "Vocês reforçam a porta contra arrombamento?",
        a: "Sim, com contra-testa reforçada, cilindro de segurança e reforço na região do segredo.",
      },
      {
        q: "Quanto custa trocar a fechadura de uma porta de madeira?",
        a: "Depende da peça escolhida e da adequação necessária. Envie uma foto pelo WhatsApp para orçamento.",
      },
    ],
    related: ["fechaduras-de-porta", "fechadura-digital", "chaveiro-dom-bosco", "chaveiro-a-domicilio"],
  },
  {
    slug: "fechadura-eletronica-portao",
    keyword: "fechadura eletrônica portão",
    title: "Fechadura Eletrônica para Portão em Betim | Chavel",
    description:
      "Fechadura eletrônica para portão em Betim: instalação, troca e integração com interfone e controle. Chavel - (31) 3531-3544.",
    h1: "Fechadura eletrônica para portão",
    lead: "Abrir o portão sem descer até a rua deixou de ser luxo. A fechadura eletrônica integra portão social, interfone e controle remoto em um sistema simples e barato de manter.",
    category: "produto",
    quickAnswer:
      "A Chavel instala fechadura eletrônica para portão em Betim, integrada a interfone, botoeira, controle remoto ou teclado de senha. Orçamento pelo WhatsApp (31) 3531-3544.",
    sections: [
      {
        h2: "Como funciona a instalação",
        paragraphs: [
          "A fechadura recebe um pulso elétrico que libera o trinco. Esse pulso pode vir do interfone, de uma botoeira interna, de um receptor de controle remoto ou de um teclado de senha instalado no muro.",
        ],
        bullets: [
          "Avaliação do portão e do ponto de energia disponível",
          "Instalação da fechadura e do contra-ferro alinhado",
          "Ligação ao interfone, botoeira ou receptor",
          "Teste de acionamento e ajuste do trinco",
        ],
      },
      {
        h2: "Fechadura eletrônica x elétrica",
        paragraphs: [
          "Na prática do dia a dia, os nomes se confundem. A elétrica clássica é o modelo que destrava por pulso e é a mais usada em portões sociais; a eletrônica costuma trazer recursos adicionais, como teclado de senha, controle e integração com automação.",
        ],
      },
      {
        h2: "Manutenção que evita chamado",
        paragraphs: [
          "O portão desalinhado força o trinco e queima a bobina. Alinhamento, lubrificação e verificação da fonte a cada ano prolongam muito a vida útil do conjunto.",
        ],
      },
    ],
    faq: [
      {
        q: "Funciona sem energia elétrica?",
        a: "Sem energia, o destrave elétrico não opera; por isso mantemos sempre a abertura por chave como alternativa.",
      },
      {
        q: "Dá para abrir pelo celular?",
        a: "Sim, com um módulo Wi-Fi compatível ligado ao acionamento.",
      },
      {
        q: "Vocês instalam em portão de alumínio?",
        a: "Sim, em portões de alumínio, ferro e madeira, com a fixação adequada a cada material.",
      },
    ],
    related: ["fechadura-eletrica-para-portao", "controle-de-portao", "fechadura-digital", "chaveiro-a-domicilio"],
  },
  {
    slug: "fechadura-eletrica-para-portao",
    keyword: "fechadura elétrica para portão",
    title: "Fechadura Elétrica para Portão em Betim | Instalação Chavel",
    description:
      "Fechadura elétrica para portão em Betim: venda, instalação e conserto com integração ao interfone. Chavel - (31) 3531-3544.",
    h1: "Fechadura elétrica para portão em Betim",
    lead: "É o item mais pedido em casas com portão social: abrir para a visita sem sair de dentro. Instalada corretamente, dura anos com manutenção mínima.",
    category: "produto",
    quickAnswer:
      "A Chavel vende, instala e conserta fechadura elétrica para portão em Betim, integrada a interfone e botoeira. Atendimento a domicílio pelo (31) 3531-3544.",
    sections: [
      {
        h2: "Tipos de fechadura elétrica",
        paragraphs: [
          "A escolha depende do sentido de abertura e do nível de segurança desejado.",
        ],
        h3: [
          { title: "Abertura para fora", text: "Modelo mais comum em portões sociais residenciais." },
          { title: "Abertura para dentro", text: "Requer versão específica; instalar o modelo errado gera falha rápida." },
          { title: "Fail safe e fail secure", text: "Uma destrava na falta de energia (saída de emergência), a outra mantém trancada. A escolha depende do uso do local." },
        ],
      },
      {
        h2: "Sinais de que a fechadura está falhando",
        paragraphs: [
          "Quando o portão só abre no segundo ou terceiro toque, o problema costuma estar na fonte, no alinhamento ou na bobina. Insistir com o portão desalinhado acelera a queima.",
        ],
        bullets: [
          "Zumbido sem destravar",
          "Necessidade de empurrar o portão junto com o toque",
          "Aquecimento excessivo da fechadura",
          "Trinco que não recolhe totalmente",
        ],
      },
      {
        h2: "Instalação com interfone",
        paragraphs: [
          "Fazemos a integração com interfone existente, botoeira interna e receptor de controle. Também instalamos o kit completo quando não há infraestrutura.",
        ],
      },
    ],
    faq: [
      {
        q: "Quanto custa instalar fechadura elétrica no portão?",
        a: "Varia com o modelo, a distância do ponto de energia e a necessidade de infraestrutura. Envie uma foto do portão para orçamento.",
      },
      {
        q: "Consigo abrir pelo controle do portão de garagem?",
        a: "Sim, com um receptor adicional podemos usar o mesmo controle.",
      },
      {
        q: "Vocês consertam a que já tenho?",
        a: "Sim, avaliamos fonte, bobina e alinhamento antes de indicar troca.",
      },
    ],
    related: ["fechadura-eletronica-portao", "controle-de-portao", "chaveiro-alterosa-betim", "chaveiro-a-domicilio"],
  },
  {
    slug: "controle-de-portao",
    keyword: "controle de portão",
    title: "Controle de Portão em Betim | Cópia e Programação | Chavel",
    description:
      "Controle de portão em Betim: cópia, clonagem, programação e venda de controles novos. Chavel, Av. Amazonas, 1354 - (31) 3531-3544.",
    h1: "Controle de portão: cópia, programação e troca",
    lead: "Controle é peça de uso diário e falha por motivos simples: bateria, botão gasto ou perda de programação. Quase sempre a solução é rápida e barata.",
    category: "produto",
    quickAnswer:
      "A Chavel faz cópia, clonagem e programação de controles de portão em Betim, além de vender controles novos e receptores. Loja: Av. Amazonas, 1354 - Brasiléia. Contato: (31) 3531-3544.",
    sections: [
      {
        h2: "Cópia x programação: qual é o seu caso",
        paragraphs: [
          "São procedimentos diferentes, e saber qual você precisa evita ida desnecessária à loja.",
        ],
        h3: [
          { title: "Clonagem", text: "Copia o sinal do controle original para um novo. Exige ter o controle funcionando em mãos." },
          { title: "Programação no receptor", text: "Cadastra o controle novo diretamente na central do portão, feita no local." },
          { title: "Substituição do receptor", text: "Necessária quando a central antiga não aceita mais cadastros ou perdeu a memória." },
        ],
      },
      {
        h2: "Meu controle parou de funcionar",
        paragraphs: [
          "Antes de comprar outro, teste em ordem: troque a bateria, verifique se o LED acende, teste perto do portão e observe se outro controle da casa funciona. Se nenhum funciona, o problema é na central, não no controle.",
        ],
      },
      {
        h2: "Segurança dos controles",
        paragraphs: [
          "Controles de código fixo podem ser capturados e copiados por terceiros. Modelos com rolling code (código dinâmico) mudam o sinal a cada acionamento e são a recomendação atual para portões residenciais e de condomínio.",
        ],
      },
    ],
    faq: [
      {
        q: "Preciso levar o controle original?",
        a: "Para clonagem, sim. Para programação na central, o serviço é feito no local do portão.",
      },
      {
        q: "Vocês apagam controles perdidos da memória?",
        a: "Sim, é possível limpar a memória do receptor e recadastrar apenas os controles atuais.",
      },
      {
        q: "Quanto tempo demora a cópia?",
        a: "A clonagem leva poucos minutos na loja.",
      },
    ],
    related: ["controle-portao-rossi", "controle-para-portao-eletronico", "fechadura-eletrica-para-portao", "chaveiro-betim"],
  },
  {
    slug: "controle-portao-rossi",
    keyword: "controle portão rossi",
    title: "Controle de Portão Rossi em Betim | Cópia | Chavel",
    description:
      "Controle de portão Rossi em Betim: cópia, programação e venda. Atendimento na Chavel, Av. Amazonas, 1354 - (31) 3531-3544.",
    h1: "Controle de portão Rossi",
    lead: "Rossi é uma das marcas mais usadas em portões automáticos no Brasil, e o pedido mais comum na loja é a cópia de controle para mais um morador da casa.",
    category: "produto",
    quickAnswer:
      "A Chavel faz cópia, programação e venda de controles de portão Rossi em Betim. Traga o controle original à loja na Av. Amazonas, 1354 - Brasiléia, ou chame no (31) 3531-3544.",
    sections: [
      {
        h2: "Como copiar um controle Rossi",
        paragraphs: [
          "Com o controle original funcionando, a clonagem é feita na hora. Em automatizadores com rolling code, o cadastro é feito na central do portão, o que pode exigir visita ao local.",
        ],
        bullets: [
          "Traga o controle original com bateria boa",
          "Informe o modelo do automatizador, se souber",
          "Para rolling code, agende a programação na central",
        ],
      },
      {
        h2: "Controle Rossi não funciona: o que verificar",
        paragraphs: [
          "Comece pela bateria — é a causa da maioria dos casos. Depois verifique o alcance, obstruções metálicas próximas à antena do receptor e se a antena da central está esticada.",
        ],
      },
      {
        h2: "Controles universais são compatíveis?",
        paragraphs: [
          "Alguns modelos universais funcionam bem com centrais Rossi, mas nem todos. Antes de comprar em qualquer lugar, confirme a compatibilidade — na loja fazemos esse teste na hora.",
        ],
      },
    ],
    faq: [
      {
        q: "Vocês têm controle Rossi novo à venda?",
        a: "Sim, além de controles compatíveis testados na loja.",
      },
      {
        q: "É possível copiar sem o controle original?",
        a: "Sem o original, é necessário cadastrar o controle novo diretamente na central do portão.",
      },
      {
        q: "Fazem a programação em condomínio?",
        a: "Sim, incluindo cadastro em lote para moradores.",
      },
    ],
    related: ["controle-de-portao", "controle-para-portao-eletronico", "fechadura-eletrica-para-portao", "chaveiro-alterosa-betim"],
  },
  {
    slug: "controle-para-portao-eletronico",
    keyword: "controle para portão eletrônico",
    title: "Controle para Portão Eletrônico em Betim | Chavel",
    description:
      "Controle para portão eletrônico em Betim: venda, cópia, programação e receptores. Chavel - (31) 3531-3544.",
    h1: "Controle para portão eletrônico",
    lead: "Escolher o controle certo evita retrabalho: frequência, tipo de código e compatibilidade com a central determinam se o portão vai abrir ou não.",
    category: "produto",
    quickAnswer:
      "A Chavel vende, copia e programa controles para portão eletrônico em Betim, além de instalar receptores adicionais. Loja: Av. Amazonas, 1354 - Brasiléia. Contato: (31) 3531-3544.",
    sections: [
      {
        h2: "O que define a compatibilidade",
        paragraphs: [
          "Três informações resolvem quase todos os casos: a frequência (normalmente 433 MHz), o tipo de código (fixo ou rolling code) e a marca do automatizador.",
        ],
        bullets: [
          "Frequência do sistema",
          "Código fixo x rolling code",
          "Marca e modelo da central",
          "Quantidade de controles já cadastrados na memória",
        ],
      },
      {
        h2: "Quantos controles cabem na central",
        paragraphs: [
          "Cada central tem um limite de memória. Quando ele é atingido, o cadastro novo sobrescreve ou é recusado. Nesses casos, instalamos um receptor externo com mais capacidade.",
        ],
      },
      {
        h2: "Alcance ruim: causas e solução",
        paragraphs: [
          "Antena mal posicionada, fio de antena cortado, bateria fraca e interferência de equipamentos próximos são as causas mais frequentes. O reposicionamento da antena costuma recuperar o alcance original.",
        ],
      },
    ],
    faq: [
      {
        q: "Posso usar o mesmo controle para portão e fechadura elétrica?",
        a: "Sim, com um receptor adicional ligado à fechadura.",
      },
      {
        q: "Vocês vão até o local programar?",
        a: "Sim, atendemos em residências e condomínios de Betim.",
      },
      {
        q: "Controle molhado tem conserto?",
        a: "Às vezes. Levamos para avaliação, mas placas oxidadas normalmente pedem substituição.",
      },
    ],
    related: ["controle-de-portao", "controle-portao-rossi", "fechadura-eletronica-portao", "chaveiro-betim"],
  },
];
